import type { WrapperProps } from '~/types'

export const Title = ({ children, className = '', heading = 'div' }: WrapperProps) => {
  const HeadingTag = heading;

  return <HeadingTag className={`text-list font-bold lg:text-title ${className}`}>{children}</HeadingTag>
}
